import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { memo } from "react";

interface IRowProps {
  label: string;
  value: string | React.ReactNode;
  sx?: SxProps<Theme>;
  compact?: boolean;
}

const Row: React.FC<IRowProps> = memo(({ label, value, sx, compact }) => {
  return (
    <Stack gap={compact ? 0.5 : 1}>
      <Typography variant={compact ? "caption" : "body2"}>{label}</Typography>

      {typeof value === "string" ? (
        <Typography
          fontWeight={600}
          variant={compact ? "body2" : "body1"}
          sx={sx}
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </Stack>
  );
});

export default memo(Row);
